import React__default from 'react';
import { warnOnce } from '../../utils/common.js';

const NavigationContext = React__default.createContext({});
const ConditionalContext = (props) => {
  const { children, navigation, navigationProps } = props;
  const differingKeys = Object.keys(navigationProps).filter((key) => {
    return navigationProps[key] !== navigation[key];
  });
  if (differingKeys.length === 0) {
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children);
  }
  warnOnce(`NavigationMenu: The following context values are being overridden by this NavigationMenu: ${differingKeys.join(", ")}`);
  const differingValues = Object.assign({}, ...differingKeys.map((key) => ({ [key]: navigationProps[key] })));
  return /* @__PURE__ */ React__default.createElement(NavigationContext.Provider, {
    value: differingValues,
    children
  });
};

export { ConditionalContext, NavigationContext };
